/* Good Game rebrand sections: add-to-cart form + mobile sticky bar. Vanilla, deferred, safe to load more than once. */
(function () {
  if (!customElements.get('nbd-atc-form')) {
    class NbdAtcForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.error = this.querySelector('[data-nbd-error]');
        if (!this.form) return;
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
      }
      disconnectedCallback() { if (this.form) this.form.removeEventListener('submit', this.onSubmit); }
      async onSubmit(event) {
        event.preventDefault();
        if (this.button && this.button.getAttribute('aria-disabled') === 'true') return;
        var routes = (window.theme && window.theme.routes) || {};
        var addUrl = routes.cart_add_url || '/cart/add';
        var modalCart = !!(window.theme && window.theme.settings && window.theme.settings.cartType === 'modal');
        var data = new FormData(this.form);
        if (modalCart) {
          // cart-live-region is required. The theme reads response.sections['cart-live-region']
          // unconditionally after every add; leaving it out put the string "undefined" into the
          // screen reader live region.
          data.append('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
          data.append('sections_url', window.location.pathname);
        }
        this.setLoading(true);
        try {
          var res = await fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          var json = await res.json();
          if (json.status) { this.showError(json.description || json.message || 'Could not add to cart.'); return; }
          this.showError('');
          if (modalCart) {
            // Only the shapes event goes out here. The theme's CartItems handler dispatches
            // theme:product:add itself once it has swapped the sections in, so firing it here too
            // made Klaviyo, Smile and GTM count every add twice. sourceId lets that handler find
            // the form the add came from.
            document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: { response: json, sourceId: this.form.id || null } }));
          } else {
            document.dispatchEvent(new CustomEvent('theme:product:add', { detail: { formEl: this.form, variantId: json.variant_id || json.id, cartItemCount: null, source: 'nbd-atc-form' } }));
            window.location.href = routes.cart_url || '/cart';
          }
        } catch (e) {
          this.showError((window.theme && window.theme.strings && window.theme.strings.cartError) || 'Something went wrong. Please try again.');
        } finally { this.setLoading(false); }
      }
      setLoading(on) {
        if (!this.button) return;
        if (on) { this.button.dataset.label = this.button.textContent; this.button.textContent = (window.theme && window.theme.strings && window.theme.strings.addingToCart) || 'Adding…'; this.button.setAttribute('aria-busy', 'true'); }
        else { if (this.button.dataset.label) this.button.textContent = this.button.dataset.label; this.button.removeAttribute('aria-busy'); }
      }
      showError(msg) { if (!this.error) return; this.error.textContent = msg; this.error.hidden = !msg; }
    }
    customElements.define('nbd-atc-form', NbdAtcForm);
  }

  if (!customElements.get('nbd-scroller')) {
    class NbdScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nbd-track]');
        this.buttons = Array.from(this.querySelectorAll('[data-nbd-scroll]'));
        if (!this.track) return;
        this.onClick = this.onClick.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.buttons.forEach((b) => b.addEventListener('click', this.onClick));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.setupAutoplay();
      }
      disconnectedCallback() {
        this.buttons.forEach((b) => b.removeEventListener('click', this.onClick));
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        this.stop();
      }
      // Slow carousel: one card at a time, back to the start at the end. Pauses while the
      // visitor hovers, touches, or focuses anything inside. Off under reduced motion.
      setupAutoplay() {
        var seconds = parseFloat(this.getAttribute('data-autoplay'));
        if (!seconds || seconds <= 0) return;
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.delay = seconds * 1000;
        this.paused = false;
        var pause = () => { this.paused = true; this.stop(); };
        var resume = () => { this.paused = false; this.start(); };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('touchstart', pause, { passive: true });
        this.track.addEventListener('touchend', () => setTimeout(resume, 4000), { passive: true });
        this.buttons.forEach((b) => b.addEventListener('click', () => { this.stop(); setTimeout(() => { if (!this.paused) this.start(); }, 8000); }));
        if ('IntersectionObserver' in window) {
          this.vis = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { if (!this.paused) this.start(); } else { this.stop(); } }, { threshold: 0.4 });
          this.vis.observe(this);
        } else {
          this.start();
        }
      }
      start() {
        if (this.timer || !this.delay) return;
        this.timer = setInterval(() => this.advance(), this.delay);
      }
      stop() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
      }
      advance() {
        if (document.hidden) return;
        var first = this.track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 24 : this.track.clientWidth * 0.8;
        var max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.track.scrollLeft >= max) this.track.scrollTo({ left: 0, behavior: 'smooth' });
        else this.track.scrollBy({ left: step, behavior: 'smooth' });
      }
      onClick(event) {
        var dir = parseInt(event.currentTarget.getAttribute('data-nbd-scroll'), 10) || 1;
        var first = this.track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 24 : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
      }
      onScroll() {
        var max = this.track.scrollWidth - this.track.clientWidth - 2;
        this.buttons.forEach((b) => {
          var dir = parseInt(b.getAttribute('data-nbd-scroll'), 10) || 1;
          b.disabled = dir < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
        });
      }
    }
    customElements.define('nbd-scroller', NbdScroller);
  }

  if (!customElements.get('nbd-sticky-bar')) {
    class NbdStickyBar extends HTMLElement {
      connectedCallback() {
        var anchorSel = this.getAttribute('data-watch');
        var anchor = anchorSel ? document.querySelector(anchorSel) : null;
        if (!anchor || !('IntersectionObserver' in window)) { this.dataset.visible = 'true'; return; }
        this.io = new IntersectionObserver((entries) => {
          this.dataset.visible = entries[0].isIntersecting ? 'false' : 'true';
        }, { rootMargin: '0px' });
        this.io.observe(anchor);
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
    }
    customElements.define('nbd-sticky-bar', NbdStickyBar);
  }

  // Copies the text of a target element. Used by the press boilerplate.
  if (!customElements.get('nbd-copy')) {
    class NbdCopy extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('button');
        this.target = document.getElementById(this.dataset.target || '');
        if (!this.btn || !this.target || !navigator.clipboard) { if (this.btn) this.btn.hidden = true; return; }
        this.label = this.btn.textContent;
        this.btn.addEventListener('click', () => {
          navigator.clipboard.writeText(this.target.innerText.trim()).then(() => {
            this.btn.textContent = this.dataset.done || 'Copied';
            clearTimeout(this.t); this.t = setTimeout(() => { this.btn.textContent = this.label; }, 2000);
          });
        });
      }
    }
    customElements.define('nbd-copy', NbdCopy);
  }
})();

/* Cart drawer extras. Switches a line between one-time and Subscribe & Save through /cart/change.js
   and hands the refreshed sections to the theme's own cart listeners. */
(function () {
  if (customElements.get('nbd-cart-plan')) return;
  class NbdCartPlan extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('button');
      if (!this.btn) return;
      this.btn.addEventListener('click', () => this.swap());
    }
    async swap() {
      var routes = (window.theme && window.theme.routes) || {};
      var url = (routes.cart_change_url || '/cart/change') + '.js';
      var body = { id: this.dataset.key, quantity: parseInt(this.dataset.qty, 10) || 1, selling_plan: this.dataset.plan || null,
        sections: 'cart-items,cart-footer,cart-item-count,cart-live-region', sections_url: window.location.pathname };
      this.btn.disabled = true; this.btn.setAttribute('aria-busy', 'true');
      try {
        var res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        var json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || 'Could not update');
        window.dispatchEvent(new CustomEvent('shapes:cart:cartqtychange', { detail: { response: json } }));
      } catch (e) {
        this.btn.disabled = false; this.btn.removeAttribute('aria-busy');
        var err = document.getElementById('cart-errors'); if (err) err.textContent = e.message;
      }
    }
  }
  customElements.define('nbd-cart-plan', NbdCartPlan);
})();
